import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
export const HeroSection = () => {
  const scrollToStory = () => {
    document.getElementById("story")?.scrollIntoView({
      behavior: "smooth"
    });
  };
  return <main className="relative min-h-screen flex items-center pt-20 pb-12" data-id="element-40">
      <div className="absolute inset-x-0 bottom-0 h-[40%] bg-gradient-to-t from-neutral-950 via-neutral-950/80 to-transparent" data-id="element-41" />
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 w-full" data-id="element-42">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center relative" data-id="element-43">
          <motion.div className="relative flex justify-center items-center order-1 md:order-1" initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 1,
          delay: 0.2
        }} data-id="element-44">
            <div className="w-full md:w-full max-w-[600px] relative" data-id="element-45">
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-transparent" data-id="element-46" />
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/79a84e75-868c-4058-ba46-351ea4f1987d/elliot_Large.png" alt="Professional headshot" className="w-full h-auto object-contain relative scale-110" style={{
              filter: "drop-shadow(0 25px 25px rgb(0 0 0 / 0.4))"
            }} data-id="element-47" />
            </div>
          </motion.div>
          <motion.div className="order-2 md:order-2 relative z-20 text-center md:text-left" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-48">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-49">
              Inspiring the World One Day at a Time
            </h1>
            <p className="text-lg md:text-xl text-white/80 mb-8" data-id="element-50">
              As a leader in business, I have always had a passion for bringing
              the right people together for a greater purpose. Having been a
              part of over $250M in transactions, I have learned how to add
              value to each person and investments.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-51">
              <Link to="/contact" className="px-8 py-3 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-100 transition-colors w-full sm:w-auto text-center" data-id="element-52">
                Contact Me
              </Link>
              <button onClick={scrollToStory} className="px-8 py-3 border border-white/30 text-white rounded-lg hover:bg-white/10 transition-colors w-full sm:w-auto" data-id="element-53">
                My Story
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </main>;
};